<template>
  <div class="d-flex flex-column overflow-hidden h-100">
    <vue-custom-scrollbar
      class="app-content-padding flex-grow-1 overflow-hidden h-100"
    >
      <ts-page-title
        :title="$t('levelSkillSubject.pageTitle')"
        :breadcrumb="[
          { text: $t('home'), href: '/' },
          {
            text: $t('levelSkillSubject.pageTitle'),
            href: '/admin/academic/level-skill-subjects',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
      <ts-loading-banner :loading="waiting">
        <div class="row">
          <div class="col-md-5">
            <level-skill-templete
              v-model="model"
              :validation="errors"
              ref="levelSkill"
              @clearError="clearError"
            />
          </div>
          <div class="col-md-7">
            <level-skill-subject-templete
              v-model="model"
              :validation="errors"
              class="tw-h-full"
            />
          </div>
        </div>
      </ts-loading-banner>
    </vue-custom-scrollbar>
    <div
      id="footer"
      class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2 tw-sh"
      style="background-color: #e9ecef"
    >
      <ts-button
        @click.prevent="$router.push({ name: 'level-skill-subject' })"
        :disabled="waiting_new || waiting"
        class="btn-gray"
      >
        {{ $t("cancel") }}</ts-button
      >
      <ts-button :waiting="waiting" @click.prevent="onUpdate" color="primary">
        {{ $t("update") }}</ts-button
      >
    </div>
  </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import LevelSkillTemplete from "./components/level-skill.vue";
import LevelSkillSubjectTemplete from "./components/level-skill-subject.vue";
import { mapActions, mapState } from "vuex";
import { Errors } from "form-backend-validation";
import { isEmpty } from "lodash";

export default {
  name: "levelSkillSubjectEdit",
  components: {
    LevelSkillTemplete,
    LevelSkillSubjectTemplete,
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        level_skill_id: null,
        level_skill_subjects: [],
      },
    };
  },
  created() {
    AppOptions.appContentFullHeight = true;
    AppOptions.appContentClass = "p-0";
  },
  computed: {
    ...mapState("academic/levelSkillSubject", ["edit_data", "formViewDatas"]),
  },
  methods: {
    ...mapActions("academic/levelSkillSubject", ["getFormViewData"]),
    async fetchFormViewModel({ index }) {
      this.waiting = true;
      await this.setEditData();
      await this.getFormViewData({
        index: index,
        params: {
          level_skill_id: this.edit_data.level_skill_id,
        },
      });
      await this.$refs.levelSkill.pushData(this.edit_data.skill_subjects);
      this.waiting = false;
    },
    async onUpdate() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch(
          "academic/levelSkillSubject/store",
          Object.assign({}, this.model)
        )
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearInput();
          this.$router.push({ name: "level-skill-subject" });
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },

    async setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.level_skill_id = this.edit_data.level_skill_id;
      }
    },
    clearError() {
      this.errors = new Errors();
    },
    clearInput() {
      (this.model.level_skill_id = null),
        (this.model.level_skill_subjects = []);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchFormViewModel({ index: undefined });
    });
  },
  beforeRouteLeave(to, from, next) {
    AppOptions.appContentFullHeight = false;
    AppOptions.appContentClass = "";
    next();
  },
};
</script>
